import { useMutation, useQuery } from '@tanstack/react-query'
import { ProductQrExportsFilterParams, CreateProductQrExportParams } from '@/types/product-qr-export'
import { useProductQrExportsStore } from '@/store'
import { useBulkDeleteSuccessHandler } from './use-bulk-delete'

export const useProductQrExports = (params: ProductQrExportsFilterParams) => {
  const fetchProductQrExports = useProductQrExportsStore(state => state.fetchProductQrExports)

  return useQuery({
    queryKey: ['productQrExports', params],
    queryFn: () => fetchProductQrExports(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useProductQrExport = (id: string) => {
  const getProductQrExport = useProductQrExportsStore(state => state.getProductQrExport)

  return useQuery({
    queryKey: ['productQrExport', id],
    queryFn: () => getProductQrExport(id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!id
  })
}

export const useCreateProductQrExport = () => {
  const createProductQrExport = useProductQrExportsStore(state => state.createProductQrExport)

  return useMutation({
    mutationFn: (params: CreateProductQrExportParams) => createProductQrExport(params),
    onSuccess: () => {}
  })
}

export const useDeleteProductQrExport = () => {
  const deleteProductQrExport = useProductQrExportsStore(state => state.deleteProductQrExport)

  return useMutation({
    mutationFn: (id: string) => deleteProductQrExport(id),
    onSuccess: () => {}
  })
}

export const useBulkDeleteProductQrExports = () => {
  const bulkDeleteProductQrExports = useProductQrExportsStore(state => state.bulkDeleteProductQrExports)
  const deselectAllProductQrExports = useProductQrExportsStore(state => state.deselectAllProductQrExports)
  const handleBulkDeleteSuccess = useBulkDeleteSuccessHandler()

  return useMutation({
    mutationFn: (ids: string[]) => bulkDeleteProductQrExports(ids),
    onSuccess: response => {
      deselectAllProductQrExports()
      handleBulkDeleteSuccess(response)
    }
  })
}
